import React from 'react';
import './AboutDelivery.scss';
import { Icon } from '../../../components/ui/index';

const AboutDelivery = () => {
  return (
    <>
      <div id="frame-and-lenses-step" className="about-step active">
        <div className="step-section section1">
          <div className="wrapper">
            <div className="column left">
              <Icon imgPath="/images/about/about-deliver-step4.png"></Icon>
            </div>
            <div className="column right">
              <h2>VisionHub delivers you anytime, anywhere.</h2>
              <p>
                Our delivery times change from one country to another. Contact your favorite
                retailer to make sure you have the proper details.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="delivery step-section section2">
        <div className="wrapper">
          <h3>This is your delivery, make it go where you wish.</h3>
          <ul>
            <li>
              <Icon imgPath="/images/about/home-icon.png"></Icon>
              <span className="label">At home</span>
            </li>
            <li>
              <Icon imgPath="/images/about/magasin-icon.png"></Icon>
              <span className="label">In store</span>
            </li>
            <li>
              <Icon imgPath="/images/about/building-icon.png"></Icon>
              <span className="label">At your office</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="delivery step-section section3">
        <div className="wrapper">
          <h2>Nearest kiosk where you can start the experience</h2>
        </div>
        <div className="map">&nbsp;</div>
      </div>
    </>
  );
};

export default AboutDelivery;
